import { REGISTER_START, REGISTER_COMPLETE, LOGIN_START, LOGIN_COMPLETE, LOGOFF_COMPLETE, VERIFYCODE_COMPLETE } from './account';

const initialState = {
  loggedIn: false,
  user: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case REGISTER_START:
      return {
        ...state,
        loading: true
      };
    case LOGIN_START:
      return {
        ...state,
        loading: true
      };
    case REGISTER_COMPLETE:
    case LOGIN_COMPLETE:
      if (!action.result.success) {
        return {
          ...state,
          loading: false
        };
      }
      return {
        ...state,
        user: action.result.user,
        loading: false,
        loggedIn: true
      };
    case LOGOFF_COMPLETE:
      if (!action.result.success) {
        return state;
      }
      return {
        ...state,
        user: null,
        loggedIn: false
      };
    case VERIFYCODE_COMPLETE:
      if (action.result.success) {
        return {
          ...state,
          user: action.result.user,
          loggedIn: true
        };
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./Scripts/redux/modules/auth.js